import { expValNoExposure } from '@confluence/feature-experiments';

import { useGetTemplateOnboardingViewedTime } from './useTemplateOnboardingViewedTime';

export const useShouldHideFeatureForCfind3673 = () => {
	const { templateOnboardingViewedTime, isLoading } = useGetTemplateOnboardingViewedTime();
	if (isLoading) {
		return { isLoading: true, shouldHideFeatureForCfind3673: undefined };
	}
	const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
	const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / (1000 * 60 * 60 * 24));
	const isFirstDayAfterTemplateOnboardingViewed = daysSinceOnboardingViewed === 0;
	const shouldHideFeatureForCfind3673 =
		isFirstDayAfterTemplateOnboardingViewed &&
		// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
		expValNoExposure('cfind-3673-update-onboarding-for-template-signups', 'isTreatment', false);
	return {
		isLoading,
		shouldHideFeatureForCfind3673,
	};
};
